<template>
	<div class="settings-container">
		<div class="settings-sidebar">
			<el-menu 
                :default-active="activeMenu" 
                @select="handleMenuSelect"
                class="settings-menu"
            >
				<el-menu-item 
                    v-for="item in menuList" 
                    :key="item.index" 
                    :index="item.index"
                    :class="{ 'menu-active': activeMenu === item.index }"
                >
					<span slot="title">{{ item.name }}</span>
				</el-menu-item>
			</el-menu>
		</div>
		
		<div class="settings-content">
			<!-- 平台设置 -->
			<div v-if="activeMenu === '0'" class="settings-section">
				<el-form 
			        :model="settings" 
			        label-width="120px" 
			        size="medium"
			        class="settings-form"
			    >
					<h3 class="section-title">平台设置</h3>
					
					<el-form-item label="LOGO图标" prop="value1">
						<el-col :span="16">
							<page-images v-model="settings.value8" :limit="1" />
						</el-col>
					</el-form-item>
					
					<el-form-item label="LOGO文字" prop="value1">
						<el-col :span="16">
							<page-images v-model="settings.value9" :limit="1" />
						</el-col>
					</el-form-item>
					
					<el-form-item label="平台名称" prop="value1">
						<el-col :span="10">
							<el-input 
					            v-model="settings.value10" 
					            placeholder="请输入平台名称"
					            maxlength="10"
					            show-word-limit
					        />
						</el-col>
					</el-form-item>
					
					<el-form-item class="form-actions">
						<el-button 
					        type="primary" 
					        @click="handleSaveSettings"
					        :loading="saving"
					    >
					        保存设置
					    </el-button>
					</el-form-item>
				</el-form>
			</div>
			
			<!-- 系统设置 -->
			<div v-if="activeMenu === '1'" class="settings-section">
				<el-form 
                    :model="settings" 
                    label-width="120px" 
                    size="medium"
                    class="settings-form"
                >
					<h3 class="section-title">网站设置</h3>
					
					<el-form-item label="客服电话" prop="value1">
						<el-col :span="16">
							<el-input 
                                v-model="settings.value1" 
                                placeholder="请输入客服电话"
                                maxlength="20"
                                show-word-limit
                            />
						</el-col>
					</el-form-item>
					
					<el-form-item label="联系邮箱" prop="value2">
						<el-col :span="16">
							<el-input 
                                v-model="settings.value2" 
                                placeholder="请输入联系邮箱"
                                type="email"
                            />
						</el-col>
					</el-form-item>
					
					<el-form-item label="服务时间" prop="value4">
						<el-col :span="16">
							<el-input 
                                v-model="settings.value4" 
                                placeholder="请输入服务时间"
                            />
						</el-col>
					</el-form-item>
					
					<el-form-item label="紧急救援" prop="value5">
						<el-col :span="16">
							<el-input 
                                v-model="settings.value5" 
                                placeholder="请输入24小时紧急救援"
                            />
						</el-col>
					</el-form-item>
					
					<el-form-item label="版权信息" prop="value3">
						<el-col :span="16">
							<el-input
								type="textarea"
								:autosize="{ minRows: 3, maxRows: 6 }" 
								v-model="settings.value3" 
								placeholder="请输入页脚版权信息"
								maxlength="200"
								show-word-limit
							/>
						</el-col>
					</el-form-item>
					
					<el-form-item class="form-actions">
						<el-button 
                            type="primary" 
                            @click="handleSaveSettings"
                            :loading="saving"
                        >
                            保存设置
                        </el-button>
					</el-form-item>
				</el-form>
			</div>
			
			<!-- 其他说明 -->
			<div v-if="activeMenu === '2'" class="settings-section">
				<el-form 
                    :model="settings" 
                    label-width="120px" 
                    size="medium"
                    class="settings-form"
                >
					<h3 class="section-title">其他说明</h3>
					
					<el-form-item label="开票说明" prop="value3">
						<el-col :span="16">
							<el-input
								type="textarea"
								:autosize="{ minRows: 3, maxRows: 6 }" 
								v-model="settings.value11" 
								placeholder="请输入开票说明"
								maxlength="300"
								show-word-limit
							/>
						</el-col>
					</el-form-item>
					
					<el-form-item label="投保人身份校验" prop="value3">
						<el-col :span="16">
							<el-input
								type="textarea"
								:autosize="{ minRows: 3, maxRows: 6 }" 
								v-model="settings.value12" 
								placeholder="请输入身份校验说明"
								maxlength="300"
								show-word-limit
							/>
						</el-col>
					</el-form-item>
					
					<el-form-item label="被保人身份校验" prop="value3">
						<el-col :span="16">
							<el-input
								type="textarea"
								:autosize="{ minRows: 3, maxRows: 6 }" 
								v-model="settings.value13" 
								placeholder="请输入身份校验说明"
								maxlength="300"
								show-word-limit
							/>
						</el-col>
					</el-form-item>
					
					<el-form-item label="投保提示" prop="value6">
						<el-col :span="16">
							<el-input
								type="textarea"
								:autosize="{ minRows: 3, maxRows: 6 }" 
								v-model="settings.value14" 
								placeholder="请输入投保提示"
								maxlength="500"
								show-word-limit
							/>
						</el-col>
					</el-form-item>
					
					<el-form-item label="投保说明" prop="value6">
						<el-col :span="16">
							<el-input
								type="textarea"
								:autosize="{ minRows: 3, maxRows: 6 }" 
								v-model="settings.value6" 
								placeholder="请输入投保说明"
								maxlength="500"
								show-word-limit
							/>
						</el-col>
					</el-form-item>
					
					<el-form-item label="理赔说明" prop="value7">
						<el-col :span="16">
							<el-input
								type="textarea"
								:autosize="{ minRows: 3, maxRows: 6 }" 
								v-model="settings.value7" 
								placeholder="请输入理赔说明"
								maxlength="500"
								show-word-limit
							/>
						</el-col>
					</el-form-item>
					
					<el-form-item class="form-actions">
						<el-button 
                            type="primary" 
                            @click="handleSaveSettings"
                            :loading="saving"
                        >
                            保存设置
                        </el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'SystemSettings',
		data() {
			return {
				activeMenu: '0',
				saving: false,
				menuList: [
					{
						index: '0',
						name: '平台设置'
					},
					{
						index: '1',
						name: '系统设置'
					},
					{
						index: '2',
						name: '其他说明'
					}
				],
				settings: {
					value1: '', // 客服电话
					value2: '', // 联系邮箱
					value3: '', // 版权信息
					value4: '', // 服务时间
					value5: '', // 紧急救援
					value6: '', // 投保说明
					value7: '', // 理赔说明
					value8: '', // LOGO图标
					value9: '', // LOGO文字
					value10: '', // 平台名称
					value11: '', // 开票说明
					value12: '', // 投保人身份校验说明
					value13: '', // 被保人身份校验说明
					value14: '', // 投保提示
				}
			};
		},
		mounted() {
			this.loadSettings();
		},
		methods: {
			/**
			 * 处理菜单选择
			 */
			handleMenuSelect(index) {
				this.activeMenu = index;
			},

			/**
			 * 加载设置数据
			 */
			async loadSettings() {
				try {
					this.$load();
					const res = await this.$get('sys-setting/1');
					
					// 直接使用后端返回的数据
					if (res.data) {
						Object.keys(this.settings).forEach(key => {
							if (res.data.hasOwnProperty(key)) {
								this.settings[key] = res.data[key] || '';
							}
						});
					}
				} catch (error) {
					this.$message.error(error || '加载设置失败');
				} finally {
					this.$load(false);
				}
			},

			/**
			 * 处理保存设置
			 */
			async handleSaveSettings() {
				try {
					this.saving = true;
					
					// 直接使用 settings 对象作为保存数据
					await this.$put('sys-setting/1', this.settings);
					
					this.$message.success('保存成功');
				} catch (error) {
					this.$message.error(error || '保存失败');
				} finally {
					this.saving = false;
				}
			}
		}
	};
</script>

<style lang="scss" scoped>
// 修复父级布局限制的关键代码
.settings-container {
	display: flex;
	height: 100%; // 使用父级给的高度
	min-height: 0; // 重要：允许在flex布局中收缩
	width: 100%;
	background: #fff;
	padding: 20px;
	box-sizing: border-box;
	// 不需要设置overflow，让父级处理滚动
}

.settings-sidebar {
	width: 200px;
	flex-shrink: 0;
	min-height: 0; // 重要：允许收缩
	
	.settings-menu {
		border: none;
		background: transparent;
		height: 100%; // 占满父级高度
		
		.el-menu-item {
			height: 50px;
			line-height: 50px;
			margin-bottom: 4px;
			border-radius: 4px;
			transition: all 0.3s;
			
			&:hover {
				background-color: #f5f7fa;
			}
			
			&.menu-active {
				background-color: #ecf5ff;
				color: #409eff;
				border-right: 3px solid #409eff;
				font-weight: 500;
			}
		}
	}
}

.settings-content {
	flex: 1;
	margin-left: 30px;
	padding: 20px;
	background: #fff;
	border-radius: 8px;
	min-height: 0; // 重要：允许在flex布局中收缩
	height: 100%; // 使用父级给的高度
	overflow-y: auto; // 关键：在自己的区域内滚动
	
	// 为所有滚动内容提供更好的滚动体验
	&::-webkit-scrollbar {
		width: 6px;
	}
	
	&::-webkit-scrollbar-track {
		background: #f1f1f1;
	}
	
	&::-webkit-scrollbar-thumb {
		background: #c1c1c1;
		border-radius: 3px;
	}
	
	&::-webkit-scrollbar-thumb:hover {
		background: #a8a8a8;
	}
}

.settings-section {
	max-width: 800px;
	height: auto; // 根据内容自适应
	min-height: 100%; // 确保至少有父级高度
}

.section-title {
	margin-bottom: 30px;
	padding-bottom: 15px;
	color: #303133;
	font-size: 18px;
	font-weight: 600;
	border-bottom: 1px solid #e4e7ed;
}

.settings-form {
	.el-form-item {
		margin-bottom: 24px;
		
		::v-deep .el-form-item__label {
			font-weight: 500;
			color: #606266;
		}
	}
	
	.form-actions {
		margin-top: 40px;
		padding-top: 20px;
		border-top: 1px solid #e4e7ed;
		
		.el-button {
			min-width: 120px;
		}
	}
}

// 响应式设计
@media (max-width: 768px) {
	.settings-container {
		flex-direction: column;
		padding: 10px;
		height: auto;
		min-height: 100%; // 移动端也要有最小高度
	}
	
	.settings-sidebar {
		width: 100%;
		margin-bottom: 20px;
		
		.settings-menu {
			display: flex;
			overflow-x: auto;
			flex-wrap: nowrap;
			white-space: nowrap;
			height: auto; // 移动端不限制高度
			
			.el-menu-item {
				flex: 1;
				text-align: center;
				min-width: 120px;
				
				&.menu-active {
					border-right: none;
					border-bottom: 3px solid #409eff;
				}
			}
		}
	}
	
	.settings-content {
		margin-left: 0;
		padding: 15px;
		height: auto; // 移动端自适应
		min-height: calc(100vh - 200px); // 移动端最小高度
	}
	
	.settings-form {
		.el-form-item {
			::v-deep .el-form-item__content {
				.el-col {
					width: 100%;
				}
			}
		}
	}
}

// 防止表格内容过长时的滚动问题
::v-deep .el-textarea__inner {
	resize: vertical;
	min-height: 80px;
	max-height: 200px; // 限制最大高度
	overflow-y: auto !important; // 确保内部可以滚动
}

// 图片上传组件适配
::v-deep .page-images {
	.el-upload-list {
		max-height: 200px;
		overflow-y: auto;
	}
}

// 重要：修复所有可能影响滚动的问题
::v-deep * {
	max-height: inherit;
}
</style>